<template>
	<div class="account-layout">
		<nav class="account-layout__nav-container">
			<NuxtLink :to="localePath('/')">
				<GlobalLogo />
			</NuxtLink>
			<ButtonUnderlined iconBefore="arrow-left" class="account-layout__button" :to="localePath('/')">{{
				$t('layouts.nav.back_to_homepage')
			}}</ButtonUnderlined>
		</nav>

		<div class="account-page">
			<ClientOnly>
				<div v-if="isMobile_lg" class="account-page__mobile">
					<v-window v-model="mobileView" class="account-page__window">
						<v-window-item value="menu" class="account-page__window-item">
							<AccountSidebarNav />
						</v-window-item>
						<v-window-item value="content" class="account-page__window-item">
							<button type="button" class="account-page__back" @click="mobileView = 'menu'">
								<GlobalIcon name="arrow-left" :height="16" />
								{{ $t('pages.account.back_to_menu') }}
							</button>
							<slot />
						</v-window-item>
					</v-window>
				</div>
				<div v-else class="account-page__container">
					<aside class="account-page__sidebar">
						<AccountSidebarNav />
					</aside>
					<main class="account-page__main">
						<slot />
					</main>
				</div>
				<template #fallback>
					<div class="account-page__container">
						<aside class="account-page__sidebar">
							<AccountSidebarNav />
						</aside>
						<main class="account-page__main">
							<slot />
						</main>
					</div>
				</template>
			</ClientOnly>
		</div>

		<LazyVisibleGlobalFooter hydrate-on-visible />
		<GlobalCallButton />
		<GlobalSmartAppBanner />
	</div>
</template>

<script setup lang="ts">
const { isMobile_lg } = useWindowWidth()
const localePath = useLocalePath()
const route = useRoute()
const userStore = useUserStore()
const isLogged = useCookie('is_logged')
const nuxtApp = useNuxtApp()

if (process.client && isLogged.value && !userStore.state.user) {
	userStore.fetchUser().catch(() => {})
}

const accountBaseRouteName = 'account'

const mobileView = ref<'menu' | 'content'>((route.name?.toString().slice(0, -5) ?? '') === accountBaseRouteName ? 'menu' : 'content')

// Swap to the content panel only once the destination page has actually rendered
// (Suspense resolved), so the swipe reveals real content instead of a blank panel.
// page:finish also fires once for the very first page load, which would override
// the initial menu/content state above — skip that first occurrence.
let isInitialPageFinish = true
const unhookPageFinish = nuxtApp.hook('page:finish', () => {
	if (isInitialPageFinish) {
		isInitialPageFinish = false
		return
	}
	mobileView.value = 'content'
})

onUnmounted(() => {
	unhookPageFinish()
})
</script>

<style lang="scss" src="./account.scss"></style>
